import {Component, OnInit} from '@angular/core';
import {UserService} from "../../core/service/user.service";
import {GlobalAppService} from "../../core/commons/global-app.service";
import {MessageSeverity} from "../../core/commons/message-severity";
import {Router} from "@angular/router";

@Component({
    selector: 'change-password-form',
    templateUrl: 'change-password-form.component.html',
    styleUrls: ['change-password-form.component.scss'],
    providers: [UserService]
})
export class ChangePasswordFormComponent implements OnInit {

     oldPassword: string;
     newPassword: string;
     newPasswordRepeat: string;

    constructor(private userService: UserService,
                private msgService: GlobalAppService,
                private router: Router) {
    }

    ngOnInit() {
        this.oldPassword = "";
        this.newPassword = "";
        this.newPasswordRepeat = "";
    }

    onSubmit() {
        console.log('Submit');
        if (this.newPassword == this.newPasswordRepeat) {
            this.userService.changePass(this.oldPassword, this.newPassword)
                .subscribe(
                    res => {
                        this.msgService.sendMsg(MessageSeverity.SUCCESS, "Éxito", "Se ha cambiado la contraseña exitosamente.")
                        this.router.navigate(['home']);
                    },
                            err => this.msgService.sendMsg(MessageSeverity.ERROR, "Error", "Ha ocurrido un error al intentar cambiar su contraseña.")
                    );
        } else
            this.msgService.sendMsg(MessageSeverity.ERROR, "Error", "Las contraseñas no coinciden.");
    }



}



// WEBPACK FOOTER //
// ./src/app/personal-config/change-password-form/change-password-form.component.ts